import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { Button } from '@/components/ui';

export function RootErrorBoundary() {
    const error = useRouteError();
    const navigate = useNavigate();
    const is404 = isRouteErrorResponse(error) && error.status === 404;
    const statusCode = isRouteErrorResponse(error) ? error.status : 500;
    const title = is404 ? 'Page not found' : 'Something went wrong';
    const detail = is404
        ? 'The page you followed has moved, expired, or never existed.'
        : 'An unexpected error occurred. Try going back and starting again.';

    return (
        <div className="flex-1 flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md flex flex-col items-start gap-6">
                <img src="/logos/septima.svg" alt="Septima" className="h-7 w-auto" />
                <div className="flex flex-col gap-2">
                    <span className="text-overline uppercase font-mono tabular-nums text-[rgb(var(--color-text-tertiary))]">
                        Error {statusCode}
                    </span>
                    <h1 className="text-screen-title text-[rgb(var(--color-text-primary))]">
                        {title}
                    </h1>
                    <p className="text-body text-[rgb(var(--color-text-secondary))]">{detail}</p>
                </div>
                <div className="flex items-center gap-3">
                    <Button variant="primary" onClick={() => navigate('/')}>
                        Back to home
                    </Button>
                    <Button variant="ghost" onClick={() => window.history.back()}>
                        Go back
                    </Button>
                </div>
            </div>
        </div>
    );
}
